module.exports = __webpack_public_path__ + "static/media/product_sample_7.6d06549f.jpg";